import { Cycle } from '@/v2/v3/Cycle'

export function V2CyclePage() {
  return <Cycle />
}
